import { render, staticRenderFns } from "./RecipesOverview.vue?vue&type=template&id=d53be58e&"
import script from "./RecipesOverview.vue?vue&type=script&lang=js&"
export * from "./RecipesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports